import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'

const getAlgorithms = (application) => {
  return clientHTTP.getAll(getLinkHref(application, 'algorithms'), { sort: '+name' })
}

const getEndDevicePositions = (endDevice, params = {}) => {
  return clientHTTP.get(getLinkHref(endDevice, 'endDevicePositions'), params)
}

const getEndDevicePositionGateways = (endDevice, params = {}) => {
  return clientHTTP.get(getLinkHref(endDevice, 'endDeviceGatewaysPositions'), params)
}

export default {
  getAlgorithms,
  getEndDevicePositions,
  getEndDevicePositionGateways
}
